import { useState, useEffect } from "react";
import { getProjectStats } from "../../backend-services";
import { ProjectStatsData } from "../../@types/project";

export function useProjectStatsData(startDate: Date, endDate: Date) {
  const [projectData, setProjectData] = useState<ProjectStatsData | null>(null);
  const [error, setError] = useState<string | null>(null);
  const fetchData = async () => {
    try {
      const response = await getProjectStats(
        startDate.toISOString(),
        endDate.toISOString(),
      );

      const data: ProjectStatsData = {
        totalProjects: response.totalProjects.value,
        totalInProgressProjects: response.totalInProgressProjects.value,
        totalCancelledProjects: response.totalCancelledProjects.value,
        totalCompletedProjects: response.totalCompletedProjects.value,
        prevEndDate: response.prevEndDate,
        prevStartDate: response.prevStartDate,
        // dateRange: `${startDate.toDateString()} - ${endDate.toDateString()}`,
      };
      setProjectData(data);
      setError(null);
    } catch (error) {
      setError("Failed to fetch expense statistics");
    }
  };

  useEffect(() => {
    fetchData();
  }, [startDate, endDate]);

  return { projectData, error, fetchProjectStat: fetchData };
}
